var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('router-view',{class:{'_padding-top769w': _vm.$route.path != '/discover'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }